import { NgModule } from '@angular/core';
import { CoreModule } from '@app/core/core.module';
import { SharedModule } from '@shared/shared.module';

import { LayoutRoutingModule } from './layout.routing.module';

import { MainPageComponent } from './main-page/main-page.component';
import { LoginComponent } from './access/login/login.component';
import { AccessDeniedComponent } from './access/access-denied/access-denied.component';

@NgModule({
    declarations: [],
    imports: [MainPageComponent, LoginComponent, AccessDeniedComponent, LayoutRoutingModule, CoreModule, SharedModule],
    providers: [],
    exports: [MainPageComponent, LoginComponent, AccessDeniedComponent],
})
export class LayoutModule {}
